<template>
	<div class="styles-app-structure-main">
		<div class="row">
			<div class="col-12">
				<div class="element-box p-0">
					<div class="head">
						<h2 class="Register-title">{{ t.registration.form }}</h2>
					</div>
					<div class="element-content register-form px-5 pb-5">
						<symForm :options="opt" :data="formData" v-on:sended="getUserForm" :form="userForm" :formProcess="formProcess" v-if="userForm" />
					</div>
				</div>
			</div>
			<div class="col-12">
				<resetting />
			</div>
		</div>
	</div>
</template>

<script>

    import symForm from '@/components/form/symForm.vue'
    import globalLoader from '@/components/ui/loader/globalLoader.vue'
    import Login from '@/components/auth/Login.vue'
    import Resetting from '@/components/user/form/resetting.vue'

    export default {
        name: 'register',
        components: { symForm, globalLoader, Login, Resetting },
        data () {
            return {
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                regions: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                },
                formData: []
            }
        },
        mounted () {
            this.getUserForm();
            this.fetchRegions();
        },
        notifications: {
            showFormError: { // You can have any name you want instead of 'showLoginError'
                title: 'Login Failed',
                message: 'Failed to authenticate',
                type: 'error' // You also can use 'VueNotifications.types.error' instead of 'error'
            }
        },
        methods: {
            async fetchRegions () {

                this.$http.get(api+'api/v1/regions')
                    .then(response => {

                        this.regions = response.body.result.regions;
                    }, response => {

                    })
            },
            async getUserForm (data) {


                    this.userForm = null;
                    this.formProcess = 0;
                    this.$bus.$emit('globalLoader', 1);
                    if(data) {
                        var ref = (this.$route.query.ref) ? this.$route.query.ref : '';
                        //this.userForm = null;
                        this.$http.post(api+'api/v1/user/registration/form?ref='+this.$route.query.ref,
                            data )
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formProcess = 200;

                                swal('', this.t.registration.success, "success")
                                this.$bus.$emit('globalLoader', 0);

                                setTimeout(
                                    this.redirectHome()
                                , 3000);

                            }, response => {
                                this.userForm = response.body.result;
                                this.formProcess = 400;
                                //swal(this.t.processing.error, this.t.processing.check, "error")
                                this.$bus.$emit('globalLoader', 0);
                            })

                    } else {
                        this.$http.get(api+'api/v1/user/registration/form')
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formData = response.body.form_data;
                                this.opt.region.data = this.regions;
                                this.opt.region.label = 'name'
                                this.$bus.$emit('globalLoader', 0);

		                        var language = window.navigator.userLanguage || window.navigator.language;

		                        setTimeout(() => {

		                            var v = this.getIpInfo().then(response => {
                                            var ip = response.body;

                                            document.getElementById("registration_region").text = ip.country;
                                            document.getElementById('registration_mobilePhone_country').value=ip.countryCode;

					                    }, response => {

				                        })

		                            document.getElementById('registration_timezone').value=Intl.DateTimeFormat().resolvedOptions().timeZone;
		                        }, 1000);

                        }, response => {
                                this.$bus.$emit('globalLoader', 0);
                        })
                    }

            },
	        redirectHome () {
                window.location.href = '/';
	        },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .Register-title {
        font-size: 35px;
        text-align: center;
    }

    .help-block {
        text-align: right;
        color: red;
        font-weight: bold;
        font-size: 14px;
    }

    .register-form {
        padding-top: 30px;
        float: left;
        border-radius: 2px;
    background-color: var(--white);
    box-shadow: 0 0 2px 0 rgba(var(--black-box-shadow-rgb),.14),0 1px 3px 0 rgba(var(--black-box-shadow-rgb),.14);
    }

	.register-form .form-group {
		float: left !important;
		width: 20% !important;
		max-height: 65px;
		padding: 5px;
	}

	#registration_mobilePhone_number,#registration_mobilePhone_country {
		width: 100%;
	}

	#registration_dateOfBirth select{
		width: 33.1%;
	}

	.register-btn {
		margin: 100px 0 50px;
		float: left;
		font-size: 30px;
		line-height: 45px;
	}

</style>



// WEBPACK FOOTER //
// src/components/user/registration.vue